module.exports = __webpack_public_path__ + "assets/5eed056893ce7493d57353bc623c787a.mp3";